var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useEffect, useState, } from 'react';
import { useFormContext } from 'react-hook-form';
import { useSafeFormData, } from '../types/index';
import { useCalendarIntegrationsContext } from '../context/CalendarIntegrationContext';
import { useHandleEventUpdate } from '../hooks/useHandleEventUpdate';
import { useEventComposerGlobalContext } from './EventComposerGlobalContext';
import { useEventApi } from '../hooks/useEvent/useEventApi';
import { useConfig } from '../context/ConfigContext';
import { useSpacePrivacySettings } from '../hooks/useSpacePrivacySettings';
var EditEventContext = createContext({
    initialEvent: undefined,
    eventPermissions: undefined,
    handleEventUpdate: function () { },
    recurringEventToUpdate: null,
    setRecurringEventToUpdate: function () { },
    editEventError: null,
    updatingEvent: false,
    setEditEventError: function () { },
    shouldShowPrivacyIndicator: false,
    spaceReservationVisibilityEnabled: false,
});
export var EditEventContextProvider = function (_a) {
    var _b, _c;
    var children = _a.children, onClose = _a.onClose, onSubmit = _a.onSubmit, onEventChange = _a.onEventChange, initialEvent = _a.initialEvent, eventPermissions = _a.eventPermissions, fetchingEvent = _a.fetchingEvent;
    var _d = useConfig(), tenantId = _d.tenantId, environmentUrls = _d.environmentUrls, userContext = _d.userContext, accessToken = _d.accessToken;
    var _e = useEventComposerGlobalContext(), timezone = _e.timezone, onError = _e.onError;
    var apiUrl = environmentUrls.apiUrl, baseApiUrl = environmentUrls.baseApiUrl;
    var currentOrg = userContext.currentOrg;
    var subscribe = useFormContext().subscribe;
    var formData = useSafeFormData();
    var _f = useEventApi({
        onError: onError,
        apiUrl: apiUrl,
        baseApiUrl: baseApiUrl,
        currentOrg: currentOrg,
        tenantId: tenantId,
        accessToken: accessToken,
    }), updateEvent = _f.updateEvent, editEventError = _f.eventError, setEditEventError = _f.setEventError, updatingEvent = _f.composingEvent;
    var _g = useCalendarIntegrationsContext(), calendarType = _g.calendarType, calendarMailboxAddress = _g.calendarMailboxAddress;
    var _h = __read(useState(null), 2), recurringEventToUpdate = _h[0], setRecurringEventToUpdate = _h[1];
    var _j = useSpacePrivacySettings({
        spaceSettings: ((_c = (_b = formData.spaces) === null || _b === void 0 ? void 0 : _b.find(function (space) { return space.id === Number(initialEvent === null || initialEvent === void 0 ? void 0 : initialEvent.spaceId); })) === null || _c === void 0 ? void 0 : _c.settings) || [],
    }), spaceReservationVisibilityEnabled = _j.spaceReservationVisibilityEnabled, shouldShowPrivacyIndicator = _j.shouldShowPrivacyIndicator;
    var handleEventUpdate = useHandleEventUpdate({
        formData: formData,
        timezone: timezone,
        initialEvent: initialEvent,
        calendarType: calendarType,
        calendarMailboxAddress: calendarMailboxAddress,
        updateEvent: updateEvent,
        setRecurringEventToUpdate: setRecurringEventToUpdate,
        onError: onError,
        onClose: onClose,
        onSubmit: onSubmit,
    }).handleEventUpdate;
    useEffect(function () {
        if (fetchingEvent)
            return;
        if (!onEventChange)
            return;
        var callback = subscribe({
            formState: {
                values: true,
            },
            callback: function (_a) {
                var values = _a.values;
                onEventChange(values);
            },
        });
        return function () { return callback(); };
    }, [subscribe, onEventChange, fetchingEvent]);
    return (_jsx(EditEventContext.Provider, { value: {
            initialEvent: initialEvent,
            eventPermissions: eventPermissions,
            handleEventUpdate: handleEventUpdate,
            recurringEventToUpdate: recurringEventToUpdate,
            setRecurringEventToUpdate: setRecurringEventToUpdate,
            editEventError: editEventError,
            updatingEvent: updatingEvent,
            setEditEventError: setEditEventError,
            shouldShowPrivacyIndicator: shouldShowPrivacyIndicator,
            spaceReservationVisibilityEnabled: spaceReservationVisibilityEnabled,
        }, children: children }));
};
export var useEditEventContext = function () {
    return useContext(EditEventContext);
};
